<template>
  <v-container id="drive-log-detail">
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn color="grey" @click="$router.go(-1)" outlined iconName="mdi-format-list-bulleted-square">돌아가기</c-btn>
      </v-col>
    </v-row>
    <c-card v-if="this.details">
      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">예약정보</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <c-btn color="blue" outlined :to="`/reservation/${reservationInfo.reservationId}`"> 예약정보 확인하기</c-btn>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="font-weight-black">예약자</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span style="cursor: pointer"
                @click="$router.push(`/customers/${details.customerId}`)">{{ details.customerName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="font-weight-black">예약 날짜</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span>{{ reservationInfo.receptionDate ? $func.dateTimeToString(reservationInfo.receptionDate) : ''}}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="font-weight-black">연락처</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span>{{ details.mobileNo }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="font-weight-black">비상 연락처</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span v-html="familyContactList"></span>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12">
          <span class="font-weight-black">[기사 정보]</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기사 이름</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
              <span style="cursor: pointer"
                    @click="$router.push(`/drivers/${reservationInfo.driverId}`)"> {{ reservationInfo.driverName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">차종/모델명</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span> {{ reservationInfo.vehicleType }} / {{ reservationInfo.modelName }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기사 연락처</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ reservationInfo.driverNumber }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">차량번호</span>
        </v-col>
        <v-col cols="12" md="4" sm="4">
          <span>{{ reservationInfo.plateNo }}</span>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12">
          <span class="font-weight-black">[주행 정보]</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">총 서비스 시간</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span> {{ displayDuration(this.details.totalDuration) }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">출발지</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.reservationRouteList && this.details.reservationRouteList.length > 0 ? this.details.reservationRouteList[0].position : '-' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">출발 시간</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.startTime ? $func.dateTimeToString(this.details.startTime) : ''}}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도착지</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.reservationRouteList && this.details.reservationRouteList.length > 1 ? this.details.reservationRouteList[1].position : '-' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도착 시간</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.endTime ? $func.dateTimeToString(this.details.endTime):'' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">탑승 인원</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.riderCount }} 명</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">대기 시간</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ displayDuration(this.details.waitDuration) }}<br>{{ this.waitLog.join(", ") }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도움서비스 시간</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDuration(this.details.serviceDuration) }}<br>{{ this.serviceLog.join(", ") }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도움서비스</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <template v-if="this.reservationInfo && this.reservationInfo.helpService">
            <v-row>병원동행
              <c-btn
                  :disabled="!this.details.driveStatus || this.details.driveStatus.configValue === 'ds_cancel'"
                  small
                  color="blue"
                  class="ml-3"
                  outlined
                  @click="openHelpServiceDialog"
              >
                도움 서비스 정보 입력
              </c-btn>
            </v-row>
            <v-row class="mt-2">
              <span>{{ getHelpServiceMatchingInfo() }} | {{ getHelpServiceInfo() }}</span>
            </v-row>
          </template>
          <template v-else>
            -
          </template>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">OBD2 측정 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span> {{ displayDistance(this.details.collectedTotalDistance).toFixed(3) }} km</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">기준 주행 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDistance(details.selectedTotalDistance).toFixed(3) }} km</span>
          <span> ({{ this.details.selectedDistanceType ?  this.details.selectedDistanceType : 'OBD2 주행 거리' }})</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">GPS 주행 거리</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ displayDistance(this.details.totalDistance).toFixed(3) }} km </span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">지도 계산 거리</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ displayDistance(this.details.apiSupportedDistance).toFixed(3) }} km</span>
        </v-col>

      </v-row>

      <v-row align="center" class="my-2">
        <v-col cols="6">
          <div id="naverMap" style="position:relative; width:100%;height:500px;padding:0;margin:0;"></div>
        </v-col>
        <v-col cols="6">
          <div id="locationTable">
            <div class="tableScroll">
              <c-table :headers="headers1" :items="pathLogItems" @click="onClickTableRow"
                       hide-default-footer disable-pagination v-model="selectedMarker2"
                       single-select item-key="idx">
              </c-table>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider/>

      <v-row align="center" class="my-4">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">[결제 정보]</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <c-btn color="blue" outlined @click="onUpdateDriveLogUpdatePayDialog"> 결제정보 변경하기</c-btn>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">총 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.totalFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">결제 상태</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.payStatus ? this.details.payStatus.configName : '-' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">주행 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.driveFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">실 결제 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.paidFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">대기 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.waitFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">미수금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.unpaidFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">도움서비스 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.serviceFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">결제 수단</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ this.details.payMethod ? this.details.payMethod.configName : '' }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">추가 요금</span>
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <span>{{ Number(this.details.extraFee).toLocaleString() }}</span>
          <c-btn v-if="showPayLog" color="grey" icon iconName="create" iconSize="16"
                 @click="onUpdateDriveLogUpdateFee"/>
        </v-col>

        <template v-if="this.showExtraPayInfo">
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 일시</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayTime ? $func.dateToString(this.details.extraPayTime):'' }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 수단</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayMethod.configName }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제 금액</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ Number(this.details.extraPaidFee).toLocaleString() }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">추가 결제자 이름</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span>{{ this.details.extraPayCustomerName }}</span>
          </v-col>
        </template>


      </v-row>


      <template v-if="this.showPayLog">
        <v-divider/>
        <v-row justify="center" class="my-4">
          <v-col cols="12">
            <span class="font-weight-black">[결제 내역]</span>
          </v-col>
          <v-col cols="12">
            <c-table :headers="headers2" :items="payListItems" hide-default-footer
                     disable-pagination item-key="idx">
              <template #payLogType="{item}">
                {{item.payLogType ? item.payLogType.configName : '-'}}
              </template>
              <template #datetime="{item}">
                {{$func.dateTimeToString(item.logTime)}}
              </template>
              <template #detail="{ item }" >
                <div v-if="showDetailButton(item.payLogType)">
                  <c-btn icon iconName="search" @click="onShowDetailPayLog(item.payLogType, item)"></c-btn>
                </div>
              </template>
            </c-table>
          </v-col>
        </v-row>
      </template>

    </c-card>

    <drive-log-update-fee-dialog
        :open.sync="updateDriveLogUpdateFeeDialog"
        :driveLogFeeFormData="driveLogFeeFormData"
        :driveLogFeeInfo="driveLogFeeInfo"
        @reqUpdateDriveLogFee="reqUpdateDriveLogFee"
    />
    <drive-log-update-pay-dialog
        :open.sync="updateDriveLogUpdatePayDialog"
        :driveLogPayFormData="driveLogPayFormData"
        @reqUpdateDriveLogPay="reqUpdateDriveLogPay"
    />
    <drive-log-card-log-dialog
        :open.sync="openDriveLogCardLogDialog"
        :driveLogCardLogData="driveLogCardLogData"
    />
    <drive-log-admin-dialog
        :open.sync="openDriveLogAdminDialog"
        :driveLogAdminData="driveLogAdminData"
    />
    <v-dialog v-if="helpServiceFormDialog" v-model="helpServiceFormDialog" max-width="600px">
      <c-card class="white">
        <v-card-title class="mb-5">도움 서비스 정보 입력</v-card-title>
        <v-radio-group v-model="helpServiceFormData.isMatching" row class="ma-0" label="동행 매니저">
          <v-radio label="미배정" :value="false"></v-radio>
          <v-radio label="배정" :value="true"></v-radio>
        </v-radio-group>
        <v-col>
          <span class="ml-1">동행 매니저 이름</span>
          <v-text-field class="my-3" v-model="helpServiceFormData.managerName" placeholder="이름을 입력해주세요"
                        solo dense required :rules="[v => !!v]" maxLength="32"
                        hide-details color="navy" maxlength="32"/>
        </v-col>
        <v-col>
          <span class="ml-1 mb-2">동행 매니저 연락처</span>
          <v-row justify="space-around" align="center">
            <v-col cols="3" class="mr-0 pr-0">
              <v-text-field v-model="helpServiceFormData.mobileNo1" v-mask="['##','###']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
            <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
            <v-col cols="3" class="mx-0 px-0">
              <v-text-field id="mobileNo2C" v-model="helpServiceFormData.mobileNo2" v-mask="['###','####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
            <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
            <v-col cols="3" class="ml-0 pl-0">
              <v-text-field id="mobileNo3C" v-model="helpServiceFormData.mobileNo3" v-mask="['####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-row justify="center">
          <c-btn @click="onRegisterHelpManager" outlined color="primary">저장</c-btn>
          <c-btn @click="helpServiceFormDialog = false" class="ml-1" outlined>취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DriveLogUpdateFeeDialog from "@/views/Default/DriveLog/DriveLogUpdateFeeDialog";
import DriveLogUpdatePayDialog from "@/views/Default/DriveLog/DriveLogUpdatePayDialog";
import DriveLogCardLogDialog from "@/views/Default/DriveLog/DriveLogCardLogDialog";
import DriveLogAdminDialog from "@/views/Default/DriveLog/DriveLogAdminDialog";
import VehicleDetail from "@/views/Default/Vehicle/VehicleDetail";

export default {
  components: {
    VehicleDetail,
    DriveLogUpdatePayDialog, DriveLogUpdateFeeDialog, DriveLogCardLogDialog, DriveLogAdminDialog
  },
  data() {
    return {
      param: this.$route.params,
      details: null,
      reservationInfo : null,
      waitLog: [],
      serviceLog: [],
      driveLogFeeFormData: {},
      driveLogPayFormData: {},
      driveLogCardLogData: {},
      driveLogFeeInfo: {},
      driveLogAdminData: {},
      showExtraPayInfo: false,
      showPayLog: false,
      naverMap: null,
      naverMapBound: {north: null, south: null, west: null, east: null},
      marker0: null,
      marker1: null,
      marker2: null,
      selectedMarker2: [],
      lines: [],
      headers1: [
        {text: '위치번호', value: 'idx', align: 'center', sortable: false},
        {text: '시간', value: 'time', align: 'center', sortable: false},
        {text: '위치', value: 'address', align: 'center', sortable: false}
      ],
      headers2: [
        {text: '종류', value: 'payLogType', align: 'center', sortable: false},
        {text: '시간', value: 'datetime', align: 'center', sortable: false},
        {text: '전체요금', value: 'totalFee', align: 'center', sortable: false},
        {text: '대기요금', value: 'waitFee', align: 'center', sortable: false},
        {text: '주행요금', value: 'driveFee', align: 'center', sortable: false},
        {text: '도움서비스요금', value: 'serviceFee', align: 'center', sortable: false},
        {text: '추가요금', value: 'extraFee', align: 'center', sortable: false},
        {text: '실결제요금', value: 'paidFee', align: 'center', sortable: false},
        {text: '미수금', value: 'unpaidFee', align: 'center', sortable: false},
        {text: '추가결제요금', value: 'extraPaidFee', align: 'center', sortable: false},
        {text: '상세보기', value: 'detail', align: 'center', sortable: false}
      ],
      pathLogItems: [],
      payListItems: [],
      updateDriveLogUpdateFeeDialog: false,
      updateDriveLogUpdatePayDialog: false,
      openDriveLogCardLogDialog: false,
      openDriveLogAdminDialog: false,
      helpServiceFormDialog: false,
      helpServiceFormData: {
        isMatching: false,
        managerName: '',
        mobileNo1: '',
        mobileNo2: '',
        mobileNo3: '',
      }
    }
  },
  async mounted() {
    await this.reqDriveLogDetails();
    await this.reqDriveLog2PayLog();
    await this.initMap();
    await this.setMapInfo(); //NOTE reqDriveLogDetails 호출한 뒤에 해야함, 페이지 로딩시 한번만 호출.

  },
  computed: {
    familyContactList() {
      const familyContactRelationList =
          [
            {text: '가족', value:'가족'},
            {text: '친구, 지인', value:'친구,지인'},
            {text: '복지사', value:'복지사'},
            {text: '기타', value:'기타'}
          ];
      if(this.details.familyContact) {
        let familyContactList = JSON.parse(this.details.familyContact);

        return familyContactList.map(contact => {
          let relation = familyContactRelationList.find(item => item.value === contact.relation);
          // familyContactRelationList 이외에 이전에 입력한 관계정보를 detail화면에서 표시는 해줌.
          relation = relation ? relation.text : contact.relation;
          return contact.phone + ' &nbsp ' + relation;
        }).join('<br/>');
      }
    }
  },
  methods: {
    initMap() {
      // map 띄우기위한 initialize
      this.naverMap = new naver.maps.Map("naverMap", {
        center: new naver.maps.LatLng(37.523706, 126.925468),
        zoom: 7,
        minZoom: 10
      });

      window.naverMap = this.naverMap;
      naver.maps.Event.once(naverMap, 'init_stylemap', function () {
        try {
          var rightBottomControlHtml = '<div style="width : 10px; height : 30px;"></div>';
          var rightBottomControl = new naver.maps.CustomControl(rightBottomControlHtml, {
            position: naver.maps.Position.RIGHT_BOTTOM
          });
          var zoomControl = new naver.maps.ZoomControl({
            position: naver.maps.Position.RIGHT_BOTTOM,
            style: naver.maps.ZoomControlStyle.LARGE
          });

          rightBottomControl.setMap(naverMap);
          zoomControl.setMap(naverMap);
        } catch (err) {
          console.error(err);
        }
      });
    },
    setMapInfo() {
      if(!this.details || !this.details.reservationRouteList || !(this.details.reservationRouteList.length > 0)) {
        return;
      }
      this.createMarker({ lat : this.details.reservationRouteList[0].lat, lng : this.details.reservationRouteList[0].lng, field:'departure', name:'출발지', toBind: 'marker0'})
      if (this.details.reservationRouteList.length > 1) {
        this.createMarker({ lat : this.details.reservationRouteList[1].lat, lng : this.details.reservationRouteList[1].lng, field:'destination', name:'도착지', toBind: 'marker1'});
      }

      if (this.marker2 != null) {
        this.marker2.setMap(null);
        this.marker2 = null;
      }
      this.lines = [];
      this.drawPolyLine();
    },
    createMarker(locationData) {
      let marker = locationData.field === 'departure' ? this.marker0 : this.marker1;

      if (locationData.lat && locationData.lng) {
        this.arrangeNaverMapBound(locationData.lat, locationData.lng);
        if (marker == null) {
          marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(locationData.lat, locationData.lng),
            map: this.naverMap,
            icon: {
              content: [
                `<div class="marker2u ` + locationData.toBind + `">`,
                `<div class="head">` + locationData.name +`</div>`,
                `<div class="line"></div>`,
                `<div class="point"</div>`,
                `</div>`,
              ].join(""),
              size: new naver.maps.Size(83, 61),
              anchor: new naver.maps.Point(41, 57)
            }
          });
        } else {
          marker.setPosition(new naver.maps.LatLng(locationData.lat, locationData.lng));
        }
      } else if (marker != null) {
        marker.setMap(null);
        marker = null;
      }

      if (this.marker2 != null) {
        this.marker2.setMap(null);
        this.marker2 = null;
      }

      if(locationData.field === 'departure') {
        this.marker0 = {...marker};
      } else {
        this.marker1 = {...marker};
      }
    },
    drawPolyLine() {
      this.pathLogItems=[];

      let idx = 1;
      let naverMapPath = [];
      let prevTimestamp = 0;
      let prevItem = {};
      let pathLog = JSON.parse(this.details.pathLog);

      pathLog.forEach((item, i) => {
        let timestamp = this.$moment(item[0]).format("X");
        if (item[3]) {
          this.pathLogItems.push({
            idx: idx++,
            time: this.displayTime(item[0]),
            lat: item[1],
            lng: item[2],
            address: item[3]
          });
        }

        this.arrangeNaverMapBound(item[1], item[2]);

        if ((i > 0 && timestamp - prevTimestamp > 60)) {
          let line = new naver.maps.Polyline({
            map: this.naverMap,
            path: naverMapPath,
            strokeColor: '#046bd8',
            strokeWeight: 3
          });
          this.lines.push(line);

          naverMapPath = [];
          naverMapPath.push(new naver.maps.LatLng(prevItem[1], prevItem[2]));
          naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));

          let shortdashLine = new naver.maps.Polyline({
            map: this.naverMap,
            path: naverMapPath,
            strokeColor: '#046bd8',
            strokeWeight: 3,
            strokeStyle: "shortdash"
          });
          this.lines.push(shortdashLine);

          naverMapPath = [];
        } else if (i == pathLog.length - 1) {
          if (naverMapPath.length > 0) {
            naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));
            var line = new naver.maps.Polyline({
              map: this.naverMap,
              path: naverMapPath,
              strokeColor: '#046bd8',
              strokeWeight: 3,
            });
            this.lines.push(line);
          }
        }

        naverMapPath.push(new naver.maps.LatLng(item[1], item[2]));
        prevTimestamp = timestamp;
        prevItem = item;
      });
      this.fitNaverMapBound();
    },
    async reqDriveLogDetails() {
      try {
        const res = await this.$api.getDriveLogByIdVoucherTaxi(this.param.id);
        this.details = res.data;
        this.reservationInfo = res.data.driveLogReservationRes;

        // 추가결제가 있는경우 표시되는 항목
        if(this.details.extraFee != 0) {
          if(this.details.payStatus.configValue == 'ps_unpaid') {
            this.showExtraPayInfo = false;
          } else if(this.details.paidFee != this.details.totalFee) {
            this.showExtraPayInfo = true;
          }
        } else {
          this.showExtraPayInfo = false;
        }

        this.waitLog = [];
        this.serviceLog = [];
        if (this.details.statusLog) {
          let statusLog = JSON.parse(this.details.statusLog);
          for (let i = 0; i < statusLog.length; i++) {
            const log = statusLog[i];
            if (log[0] === 'ds_wait') {
              this.waitLog.push(this.displayPeriod(log[1], log[2]));
            } else if (log[0] === 'ds_service') {
              this.serviceLog.push(this.displayPeriod(log[1], log[2]));
            }
          }
        }

        this.details.totalDuration = this.details.waitDuration + this.details.driveDuration + this.details.serviceDuration;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDriveLogDetails'});
      }
    },
    async reqDriveLog2PayLog() {
      try {
        if(this.details && this.details.driveStatus.configValue == 'ds_done'){
          this.showPayLog = true;
          const res = await this.$api.getDriveLog2PayLogById(this.param.id);
          this.payListItems = res.data;
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqDriveLog2PayLog'});
      }
    },
    async reqUpdateDriveLogFee(data) {
      try {
        await this.$api.updateDriveLogFee(data);
        this.updateDriveLogUpdateFeeDialog = false;
        await this.reqDriveLogDetails();
        await this.reqDriveLog2PayLog();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateDriveLogFee'});
      }
    },
    async reqUpdateDriveLogPay(data) {
      try {
        await this.$api.updateDriveLogPay(data);
        this.updateDriveLogUpdatePayDialog = false;
        await this.reqDriveLogDetails();
        await this.reqDriveLog2PayLog();
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateDriveLogPay'});
      }
    },
    displayDuration(sec) {
      let hours = Math.floor(sec / 3600);
      let minutes = Math.floor((sec - (hours * 3600)) / 60);
      let seconds = sec % 60;

      return hours + '시간 ' + minutes + '분 ' + seconds + '초';
    },
    displayTime(str) {
      return str ? this.$moment(str).format("HH:mm:ss") : "";
    },
    displayPeriod(str0, str1) {
      return this.$moment(str0).format("HH:mm:ss") + "~" + this.$moment(str1).format("HH:mm:ss");
    },
    displayDistance(distance) {
      return distance > 0 ? Number(distance / 1000) : 0;
    },
    arrangeNaverMapBound(lat, lng) {
      if (this.naverMapBound.north == null) {
        this.naverMapBound.north = lat;
      }
      if (this.naverMapBound.south == null) {
        this.naverMapBound.south = lat;
      }
      if (this.naverMapBound.west == null) {
        this.naverMapBound.west = lng;
      }
      if (this.naverMapBound.east == null) {
        this.naverMapBound.east = lng;
      }

      this.naverMapBound.north = Math.max(this.naverMapBound.north, lat);
      this.naverMapBound.south = Math.min(this.naverMapBound.south, lat);
      this.naverMapBound.east = Math.max(this.naverMapBound.east, lng);
      this.naverMapBound.west = Math.min(this.naverMapBound.west, lng);
    },
    fitNaverMapBound() {
      if (this.naverMapBound.north == this.naverMapBound.south && this.naverMapBound.west == this.naverMapBound.east) {
        this.naverMap.setCenter(new naver.maps.LatLng(this.naverMapBound.south, this.naverMapBound.west));
      } else {
        var latOffset = (this.naverMapBound.north - this.naverMapBound.south) / 10;
        var lngOffset = (this.naverMapBound.east - this.naverMapBound.west) / 10;
        var sw = new naver.maps.LatLng(this.naverMapBound.south - latOffset, this.naverMapBound.west - lngOffset);
        var ne = new naver.maps.LatLng(this.naverMapBound.north + latOffset, this.naverMapBound.east + lngOffset);
        var bounds = new naver.maps.LatLngBounds(sw, ne);
        this.naverMap.fitBounds(bounds);
      }
    },
    onClickTableRow: function (e) {
      this.selectedMarker2 = [e];
      if (this.marker2 != null) {
        this.marker2.setMap(null);
      }
      this.marker2 = new naver.maps.Marker({
        position: new naver.maps.LatLng(e.lat, e.lng),
        map: this.naverMap,
        icon: {
          content: [
            "<div class='marker2u marker2'>",
            "<div class='head'>위치" + e.idx + "</div>",
            "<div class='line'></div>",
            "<div class='point'></div>",
            "</div>"
          ].join(""),
          size: new naver.maps.Size(83, 61),
          anchor: new naver.maps.Point(41, 57)
        }
      });
      window.vueRoot = this;
      naver.maps.Event.addListener(this.marker2, 'click', function () {
        vueRoot.marker2.setMap(null);
        vueRoot.selectedMarker2 = [];
      });
      this.naverMap.setCenter(new naver.maps.LatLng(e.lat, e.lng));
    },
    showDetailButton(payLogType) {
      const value = payLogType.configValue;
      return !(value === 'plt_pay_cash' || value === 'plt_cancel_cash');
    },
    onShowDetailPayLog(payLogType, payLog) {
      const value = payLogType.configValue;
      switch (value) {
        case 'plt_update':
        case 'plt_extra':
          this.getAdminInfoDetail(payLog.id);
          break;
        case 'plt_pay_card' :
        case 'plt_cancel_card' :
          this.getCardLogDetail(payLog.id)
        default :
          break;
      }
    },
    async getCardLogDetail(payLogId) {
      try {
        const res = await this.$api.getCardLogInfo(payLogId);
        this.driveLogCardLogData = res.data;
        this.openDriveLogCardLogDialog = true;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'getCardLogDetail'});
      }

    },
    async getAdminInfoDetail(payLogId) {
      try {
        const res = await this.$api.getEditAdminInfo(payLogId);
        this.driveLogAdminData = res.data;
        this.openDriveLogAdminDialog = true;
      } catch(err) {
        this.$store.commit('snackbar', {err, where: 'getCardLogDetail'});

      }
    },
    onUpdateDriveLogUpdateFee() {
      this.driveLogFeeFormData = {
        driveLogId: this.details.id,
        waitFee: this.details.waitFee,
        driveFee: this.details.driveFee,
        serviceFee: this.details.serviceFee,
        extraFee: this.details.extraFee
      };
      this.driveLogFeeInfo = {
        customerName: this.details.customerName,
        driverName: this.reservationInfo.driverName,
        plateNo: this.reservationInfo.plateNo,
        totalPaidFee: this.details.paidFee,
        payStatusName: this.details.payStatus.configName,
      }
      this.updateDriveLogUpdateFeeDialog = true;
    },
    onUpdateDriveLogUpdatePayDialog() {
      this.driveLogPayFormData = {
        driveLogId: this.details.id,
        extraPayMethod: this.details.extraPayMethod.configValue,
        extraPayTime: this.details.extraPayTime ? this.$func.dateToString(this.details.extraPayTime) : '',
        payStatus: this.details.payStatus.configValue,
        extraPaidFee: this.details.extraPaidFee,
        extraPayCustomerName: this.details.extraPayCustomerName,
        customerName: this.details.driveLogReservationRes.customerName
      };

      this.updateDriveLogUpdatePayDialog = true
    },
    getHelpServiceMatchingInfo() {
      if (!this.reservationInfo?.helpService) {
        return '-'
      }

      const { isMatching } = JSON.parse(this.reservationInfo.helpService)
      return isMatching
          ? '배정 완료'
          : '미배정'
    },
    getHelpServiceInfo() {
      if (!this.reservationInfo?.helpService) {
        return '-'
      }

      const { managerName, managerPhoneNo } = JSON.parse(this.reservationInfo.helpService)
      return managerName || managerPhoneNo
          ? `${managerName ?? '-'}(${managerPhoneNo ?? '-'})`
          : '-'
    },
    checkReservationState(reservationData) {
      return reservationData?.resrvState?.configValue;
    },
    openHelpServiceDialog() {
      if (!this.reservationInfo?.helpService) {
        return
      }

      const { isMatching, managerName, managerPhoneNo } = JSON.parse(this.reservationInfo.helpService)
      this.helpServiceFormData.isMatching = isMatching
      this.helpServiceFormData.managerName = managerName;
      [this.helpServiceFormData.mobileNo1, this.helpServiceFormData.mobileNo2, this.helpServiceFormData.mobileNo3] = managerPhoneNo?.split('-') ?? ['', '', '']
      this.helpServiceFormDialog = true
    },
    async onRegisterHelpManager() {
      let managerPhoneNo = ''
      if (this.helpServiceFormData.mobileNo1 || this.helpServiceFormData.mobileNo2 || this.helpServiceFormData.mobileNo3) {
        managerPhoneNo = this.helpServiceFormData.mobileNo1 + '-' + this.helpServiceFormData.mobileNo2 + '-' + this.helpServiceFormData.mobileNo3
      }

      const params = {
        isMatching: this.helpServiceFormData.isMatching,
        managerName: this.helpServiceFormData.managerName,
        managerPhoneNo: managerPhoneNo
      }
      await this.$api.addHelpServiceManager(this.reservationInfo.reservationId, params)
      await this.reqDriveLogDetails()
      this.helpServiceFormDialog = false
    }
  }
}
</script>

<style>
#locationTable {
  position: relative;
  height: 500px;
  padding-top: 48px;
}

#locationTable .tableScroll {
  height: 452px;
  overflow-y: scroll;
}

#locationTable table {
  table-layout: fixed;
  width: 100%;
}

#locationTable thead {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

#locationTable thead tr {
  display: inline-table;
  table-layout: fixed;
  width: 100%;
}

#locationTable colgroup col:nth-child(1),
#locationTable tr th:nth-child(1) {
  width: 75px;
}

#locationTable colgroup col:nth-child(2),
#locationTable tr th:nth-child(2) {
  width: 95px;
}

.marker2u {
  position: relative;
  width: 83px;
  height: 61px;
}

.marker2u .head {
  width: 83px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  padding: 12px 0px;
  font-size: 15px;
  color: white;
  border-radius: 20px;
}

.marker2u .line {
  position: absolute;
  left: 41px;
  bottom: 3px;
  width: 1px;
  height: 18px;
}

.marker2u .point {
  position: absolute;
  left: 38px;
  bottom: 0px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.marker2u.marker0 .head,
.marker2u.marker0 .line,
.marker2u.marker0 .point {
  background-color: #318aff;
}

.marker2u.marker1 .head,
.marker2u.marker1 .line,
.marker2u.marker1 .point {
  background-color: #f61955;
}

.marker2u.marker2 .head,
.marker2u.marker2 .line,
.marker2u.marker2 .point {
  background-color: #878787;
}
</style>

